import { useQuery } from '@tanstack/react-query';
import {
  fetchAllCourses,
  fetchCourseDetail,
  type Course,
  type CourseDetail,
  type FetchCoursesParams,
} from '@/lib/championsHubApi';

export function useCourses(
  params: FetchCoursesParams & { initiativeOnly?: boolean } = {}
) {
  return useQuery<Course[]>({
    queryKey: ['champions-hub', 'courses', params],
    queryFn: () => fetchAllCourses(params),
    staleTime: 60 * 60 * 1000,
    gcTime: 24 * 60 * 60 * 1000,
    refetchOnWindowFocus: false,
  });
}

export function useCourseDetail(slug: string | null, lang: 'en' | 'ar' = 'en') {
  return useQuery<CourseDetail | null>({
    queryKey: ['champions-hub', 'course-detail', slug, lang],
    queryFn: () => (slug ? fetchCourseDetail(slug, lang) : Promise.resolve(null)),
    enabled: !!slug,
    staleTime: 60 * 60 * 1000,
    gcTime: 24 * 60 * 60 * 1000,
    refetchOnWindowFocus: false,
  });
}
